import { declensionFactory } from '@app/helpers/declension';
import classNames from 'classnames';
import IconStar from './icons/star.svg';

import styles from './RatingByShop.module.scss';

const declinationReviews = declensionFactory('отзыв', 'отзыва', 'отзывов');

export const RatingByShopTemplate = ({ className, rating, reviews }: { className?: string; rating: string; reviews: number }) => {
  if (!rating || !reviews) {
    return null;
  }

  return (
    <div className={classNames(styles.WrapperRatingByShop, className)}>
      <IconStar width={20} height={20} />
      <div className={styles.Rating}>{rating}</div>
      <div className={styles.Reviews}>
        ({reviews} {declinationReviews(reviews)})
      </div>
    </div>
  );
};
